module.exports = __webpack_public_path__ + "static/media/elements2@2x.624c959c.png";